export default __webpack_public_path__ + "static/php_service_features-d216f3755fed762d261dfdd3f70ca027.svg";